import ActivationInfoModule from './info'
import ActivationPersonalDataModule from './personalData'
import ActivationTariffOptionsModule from '../tariffOptions'
import ActivationTopUpModule from '../topUp'
import ActivationPaymentModule from '../payment'
import { ActivationSubmitModule } from './submit'
import ActivationTariffsModule from '../tariffs'

const ActivationModule = {
  namespaced: true,
  modules: {
    info: ActivationInfoModule,
    tariff: ActivationTariffsModule,
    personalData: ActivationPersonalDataModule,
    tariffOptions: ActivationTariffOptionsModule,
    topUp: ActivationTopUpModule,
    payment: ActivationPaymentModule,
    submit: ActivationSubmitModule
  },
  state: {
    view: 'activationInfo'
  },
  actions: {
  },
  mutations: {
    goToStep (state, step) {
      state.view = step
    }
  },
  getters: {
    showActivationView: state => {
      return state.view
    }
  }
}

export {
  ActivationModule
}
